import { render, staticRenderFns } from "./BulkShipmentsImportSidebar.vue?vue&type=template&id=17750a35"
import script from "./BulkShipmentsImportSidebar.vue?vue&type=script&lang=js"
export * from "./BulkShipmentsImportSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports